module.exports = __webpack_public_path__ + "static/media/poster.d85f176d.jpg";